import { render, staticRenderFns } from "./AtomSpaceDropdown.vue?vue&type=template&id=aaa4db84&"
import script from "./AtomSpaceDropdown.vue?vue&type=script&lang=js&"
export * from "./AtomSpaceDropdown.vue?vue&type=script&lang=js&"
import style0 from "./AtomSpaceDropdown.vue?vue&type=style&index=0&id=aaa4db84&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/MoleculeFitoutSelector.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fatoms%2Fproject%2FAtomSpaceDropdown.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default})
